import { useTranslation } from 'react-i18next';
import Reveal from '@/components/base/Reveal';

export default function ManagementSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto grid w-full max-w-content grid-cols-1 items-center gap-12 px-4 md:px-6 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-4">
          <div className="mx-auto max-w-xs">
            <div className="overflow-hidden rounded-lg border border-background-200">
              <div className="h-72 w-full">
                <img
                  src="https://www.sn-metall.de/mediapool/126/1269216/resources/big_56587554_0_200-211.jpg"
                  alt="Axel Friedrich, Geschäftsführer der S+N Blech- und Metallverarbeitungs GmbH"
                  className="h-full w-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={120} className="lg:col-span-8">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-current" />
            {t('about.management.eyebrow')}
          </span>
          <h2 className="mt-4 text-2xl font-bold leading-tight text-foreground-950 md:text-3xl">
            {t('about.management.title')}
          </h2>
          <div className="mt-6 flex items-center gap-4">
            <div>
              <p className="font-heading text-xl font-bold text-foreground-950">{t('about.management.name')}</p>
              <p className="text-sm text-primary-600">{t('about.management.role')}</p>
            </div>
          </div>
          <blockquote className="mt-6 border-l-2 border-primary-400 pl-5 text-base italic leading-relaxed text-foreground-700">
            {t('about.management.quote')}
          </blockquote>
        </Reveal>
      </div>
    </section>
  );
}